import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const VivritiCapitalContext: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						What could revolutionize the AIF space in India?
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/VineetsImage-dO4QwpTyj2uc.jpg"
						alt="Vineet Sukumar"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Vineet Sukumar
							<Link
								href="https://www.linkedin.com/in/vineetsukumar?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Founder & Managing Director, Vivriti Group
						</Text>

						<Link
							href="https://www.linkedin.com/in/vineetsukumar?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						India’s AIF industry has come a long way since its inception a
						decade ago. What is striking about the industry is its pace of
						growth. The commitments raised, which denotes amount clients are
						willing to invest in AIFs, surpassed INR 7 lakh crore within a
						decade (in the Sep 2022 quarter). In contrast, the Mutual Fund
						industry achieved an AUM of the same level over four decades in
						mid-2009, after the first scheme (US-64 by UTI) was launched in
						1964. Between March 2018 and 2024 or over a period of six years, AIF
						commitments witnessed an annual growth of ~38%.
					</Text>
				</Box>

				<Flex alignItems="center" justifyContent="center" mx="auto" w="100%">
					<Img
						src="https://static.levocdn.com/WGLBUT82/1000144720-HXVDtJMlM1Cl.png"
						alt="Graph"
						width="70%"
						// height="250px"
						objectFit="cover"
						mt="-1rem"
					/>
				</Flex>
				<Box my="16px">
					<Text variant="blogAnswer">
						Due to increasing awareness and recognition of AIFs as a preferred
						alternative investment vehicle, the growth in the number of schemes
						was phenomenal with new entrants and demand for new schemes. As
						depicted in the chart below, the number of schemes increased nearly
						threefold between FY19 and FY25 (as of June 2024).
					</Text>
				</Box>
				<Flex alignItems="center" justifyContent="center" mx="auto" w="100%">
					<Img
						src="https://static.levocdn.com/WGLBUT82/1000144723-YhECTN2P1T6n.png"
						alt="Graph"
						width="70%"
						// height="250px"
						objectFit="cover"
					/>
				</Flex>
				<Box my="16px">
					<Text variant="blogAnswer">
						The major factor that is driving the growth in AIFs is their low
						correlation to public markets, regulatory support, and their ability
						to provide a diversified investment portfolio, mitigating the risk
						profile of investors. Hence, high net-worth individuals (HNIs) and
						family offices are increasingly preferring AIFs instead of limiting
						themselves to asset classes like traditional equity and bonds to
						diversify risk in their portfolio. Higher volatility in the market
						for traditional investments due to consequences of black swan events
						like Covid-19, geo-political tensions, etc., and other macroeconomic
						factors like inflation have been a major concern. Given these
						issues, AIFs fit well into the criteria with higher risk-adjusted
						returns and inflation hedging.
					</Text>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px">
						Huge room for growth
					</Heading>
					<Text variant="blogAnswer">
						Despite the rapid growth in the number of schemes and commitments,
						the AIF industry is yet to mature to a much larger size given the
						lesser restrictions it enjoys with respect to investment in the
						unlisted universe compared to mutual funds and the risk-return
						spectrum it offers. Its potential to grow can be gauged from its
						share in the overall asset size of pooled investment vehicles in the
						country, which is much smaller than what it is in other developed
						countries.
					</Text>
					<Flex
						my="-2rem"
						alignItems="center"
						justifyContent="center"
						mx="auto"
						w="100%"
					>
						<Img
							src="https://static.levocdn.com/WGLBUT82/1000144719-01T3tMIk5d4x.png"
							alt="Graph"
							width="70%"
							// height="250px"
							objectFit="cover"
						/>
					</Flex>
				</Box>
				<Box my="16px">
					<Heading variant="blogQuestion">The engines of growth</Heading>
					<Heading variant="blogQuestion" py="20px">
						i) HNI base
					</Heading>
					<Text variant="blogAnswer">
						Is there inherent strength to support the growth potential of AIFs
						in India? There is indeed a significant pool of wealthy individuals
						who all can be the target group to tap the underpenetrated market.
						As per a recent report, the number of ultra-high net-worth
						individuals (UHNIs) in India, with a net worth of over US$30
						million, is expected to witness the highest growth (~50%) for any
						country across the world between 2023 and 2028.
					</Text>
					<Flex
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
						mx="auto"
						w="100%"
					>
						<Img
							src="https://static.levocdn.com/WGLBUT82/1000144722-EBhZxyG4BY5u.png"
							alt="Graph"
							width="70%"
							objectFit="cover"
							my="-3rem"
						/>
						<Img
							src="https://static.levocdn.com/WGLBUT82/1000144721-4JO6lpWgkfcx.png"
							alt="Graph"
							width="70%"
							objectFit="cover"
						/>
					</Flex>
					<Box>
						<Heading variant="blogQuestion" py="20px">
							ii) Accreditation
						</Heading>
						<Text variant="blogAnswer">
							The Accreditation Investors framework, initiated by SEBI in 2021,
							holds the key to the paradigm shift in the AIF industry. This is
							primarily because the market watchdog has allowed Accreditation
							Investors under the framework to invest with ticket sizes that are
							lower than the stipulated minimum amount of INR 1 crore. The
							premise of the framework is based on a class of investors, who are
							equipped with good knowledge about the risk and returns of
							financial products, have the ability to make informed decisions
							about their investments, and meet certain income eligibility
							criteria.
						</Text>
					</Box>
					<Box>
						<Flex
							alignItems="center"
							justifyContent="center"
							mx="auto"
							w="100%"
							my="16px"
						>
							<Img
								src="https://static.levocdn.com/WGLBUT82/1000144724-UpLJWy0TRJ9J.png"
								alt="Graph"
								width="70%"
								objectFit="cover"
							/>
						</Flex>
						<Text variant="blogAnswer">
							Certificates for Accredited Investors would be provided by
							Accreditation Agencies, which can be subsidiaries of stock
							exchanges or depositories (National Securities Depository Limited
							or Central Depository Services Limited) or any other institution
							that meets the eligibility criteria. The relaxed criteria in
							minimum investment will be able to unlock the potential of the AIF
							industry by enabling investors to enter the market who were
							previously backing off due to higher ticket sizes.
						</Text>
					</Box>
					<Box my="16px">
						<Heading variant="blogQuestion" py="20px">
							iii) Digitisation
						</Heading>
						<Text variant="blogAnswer">
							Some mutual funds have a fully digitised onboarding process which
							allows seamless transaction processing with minimal Turnaround
							Time (TAT). Given the potential growth of AIFs due to the
							inclusion of smaller ticket size investors with an Accredited
							Investor framework, there is a need for digitising the onboarding
							process for AIFs.
						</Text>
						<Text variant="blogAnswer" mt="12px">
							We suggest Accreditation Agencies to consider building a digital
							infrastructure for AIFs for the onboarding process that would
						</Text>
						<UnorderedList mt="12px">
							<ListItem mb="4px">
								<Text
									fontWeight="bold"
									variant="blogAnswer"
									pl={{ md: "12px" }}
								>
									Reduce TAT to issue Accredited Investor certificate to the
									minimum.
								</Text>
							</ListItem>
							<ListItem mb="4px">
								<Text
									fontWeight="bold"
									variant="blogAnswer"
									pl={{ md: "12px" }}
								>
									Remove ambiguity between investors and Accreditation Agencies
									by providing a standardised format of the Net Worth
									certificate.
								</Text>
							</ListItem>
						</UnorderedList>
					</Box>
					<Box my="16px">
						<Heading variant="blogQuestion" py="20px">
							iv) Listing of fund units
						</Heading>
						<Text variant="blogAnswer">
							The development of a secondary market for AIFs is essential to
							ensure liquidity in the AIF industry. As per Section 14 of SEBI’s
							AIF regulations, units of close-ended AIFs may be listed on a
							stock exchange subject to a minimum tradable lot of INR 1 crore,
							after the final close of the fund or scheme.
						</Text>
						<Text variant="blogAnswer" mt="12px">
							The listing of AIF units would
						</Text>
						<UnorderedList mt="12px">
							<ListItem mb="4px">
								<Text
									fontWeight="bold"
									variant="blogAnswer"
									pl={{ md: "12px" }}
								>
									Ensure liquidity by allowing investors an easy exit
									opportunity (subject to KYC) due to dematerialisation and
									enabling price discovery in a demand-supply mechanism.
								</Text>
							</ListItem>
							<ListItem mb="4px">
								<Text
									fontWeight="bold"
									variant="blogAnswer"
									pl={{ md: "12px" }}
								>
									Create a more enabling environment for Pension Funds, which
									are more inclined to investing in listed securities according
									to PFRDA guidelines, to invest in AIF units.
								</Text>
							</ListItem>
						</UnorderedList>
						<Text variant="blogAnswer" my="16px">
							In this regard, clear operational guidelines should also be
							established by the regulator with respect to standardisation of
							contribution agreements, handling of fractionalised units,
							tradable lot sizes for Accredited Investors, and involvement of
							merchant bankers in the listing process.
						</Text>
					</Box>
				</Box>
			</Box>

			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
              connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default VivritiCapitalContext;
